import React, {useContext} from "react"
import useStyles from "./styles";
import clsx from "clsx";

import PaFormSteps from "../../../../../shared/PaFormSteps";
import PriorAuthorizationContext from "../../../../../contexts/PriorAuthorization/PriorAuthorization.context";

export const StepperIcon = ({step, id}) => {
    const classes = useStyles();
    const {create:{currentStep, steps}} = useContext(PriorAuthorizationContext);


    if (steps[step] === undefined) {
        return <></>;
    }
    const active = currentStep === step;
    const completed = steps[step].completed && step < currentStep;

    return  <div id={id} className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
    })}>
        {PaFormSteps[step].icon}
    </div>
}